import { MaterialReactTable } from 'material-react-table'

import { Message, PageWrap } from '@/components'
import { useAppContext, useTable } from '@/hooks'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'
import { useGetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetQuery } from '@/rtkApi'

import { useDeploymentsColumns } from './hooks'
import { NewDeploymentsActions } from './NewDeploymentsActions'
import { ExtEnvironmentDeploymentDto } from './types'

export const NewDeployments = () => {
	const { t } = useAppContext()

	const {
		state: { node, editMode },
	} = useDetailTabContext()
	const { data: tableData, isLoading } =
		useGetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetQuery({
			structureId: Number(node.id),
		})

	const columns = useDeploymentsColumns()

	const table = useTable<ExtEnvironmentDeploymentDto>({
		columns,
		data: tableData || [],
		customRowActions: ({ row }) => <NewDeploymentsActions row={row} />,
		editMode,
		options: {
			enableRowOrdering: false,
			state: {
				isLoading,
			},
		},
	})

	return (
		<PageWrap>
			{editMode && (
				<Message type="warn" message={t('DEPLOYED_UNPUSHED_CHANGES_WARN')} />
			)}
			<MaterialReactTable table={table} />
		</PageWrap>
	)
}
